import { UnifiedLanguageMap } from "./UnifiedLanguageMap.js";

export function LanguageProgress() {
  return <UnifiedLanguageMap />;
}
